
import { environment as local } from './environment.local';
import { environment as staging } from './environment.staging';
import { environment as prod } from './environment.prod';

const envs: any = {
    production: prod,
    staging: staging,
    local: local,
};

const appEnv = process.env.REACT_APP_ENV === undefined ? 'local' : process.env.REACT_APP_ENV;

const config = envs[appEnv];

const env = {
    ...config,
    nome: 'Enerzee',
    googleAuthenticatorPlaystore: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
    googleAuthenticatorApplestore: 'https://apps.apple.com/br/app/google-authenticator/id388497605'
};

export default env;
